import script from "./Dropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropzone.vue?vue&type=script&setup=true&lang=js"

import "./Dropzone.vue?vue&type=style&index=0&id=52c36cd8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Marcin\\Local Sites\\doktorku\\app\\public\\wp-content\\themes\\doktorku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c36cd8"]])

export default __exports__